import CustomizationCtrl from './controllers/index';
import CustomGroupShowCtrl from './controllers/show';
import customField from './directives/customField';
import customizationCreate from './directives/customizationCreate';
import customFieldOptionSelect from "./directives/customFieldOptionSelect";
import Customization from './customization.repository';
import routing from './customzation.routes';
import uirouter from 'angular-ui-router';

export default angular.module('app.customization', [uirouter])
    .config(routing)
    .controller('CustomizationCtrl', CustomizationCtrl)
    .controller('CustomGroupShowCtrl', CustomGroupShowCtrl)
    .directive('customField', () => new customField)
    .directive('customizationCreate', () => new customizationCreate)
    .directive('customFieldOptionSelect', () => new customFieldOptionSelect)
    .service('Customization', Customization)
    .name;

